import MenuItem, {
  MenuItemProps as MuiMenuItemProps
} from '@material-ui/core/MenuItem'
import MuiSelect, { SelectProps as Props } from '@material-ui/core/Select'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Icon, { IconList } from '../icons/Icons'

export type SelectProps = {
  icon?: keyof typeof IconList
} & Props
export type MenuItemProps = MuiMenuItemProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 3,
      padding: theme.spacing(1, 1.5)
    },
    svg: {
      '& > svg': {
        position: 'absolute',
        right: theme.spacing(1),
        pointerEvents: 'none'
      }
    }
  })
)

const Select: React.FC<SelectProps> = (props) => {
  const classes = useStyles(props)
  const { icon, ...rest } = props

  const iconComponent = (
    <Icon iconName={icon ? icon : 'ArrowBottomIcon'} size="small" />
  )

  return (
    <MuiSelect
      classes={{ root: classes.root }}
      className={classes.svg}
      IconComponent={(): JSX.Element => iconComponent}
      variant="outlined"
      {...rest}
    />
  )
}

export { Select, MenuItem }